import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const applicationStatusPage = {
    mobile: {    
        mainWrapper: {
            display: "flex",
            flexDirection: "column" as "column"
        },
        leftWrapper: {},
        rightWrapper: {},
        searchWrapper: {
            display: "flex",
            flexDirection: "row" as "row"
        },
        profileWrapper: {
            display: "none"
        },
        closeButton: {
            position: "absolute",
            top: "4.73vw",
            left: "20.22vw",
            width: "2.39vw",
            height: "7.56vw",
            borderRadius: "0 1.93vw 1.93vw 0",
            background: Color.DeepBlack
        },
        closeButtonIcon: {
            fill: Color.White,
            transform: "rotate(90deg)",
            width: "1.53vw",
            height: "1.18vw"
        },
        expand: {
            display: "flex",
            flexDirection: "row" as "row",
            marginTop: "3.17vw",
            alignItems: "center",
            borderRadius: "0 1.93vw 1.93vw 0",
            background: Color.DeepBlack,
            alignContent: "center",
            width: "2.39vw",
            height: "7.56vw",
            icon: {
                width: "1.53vw",
                height: "1.18vw",
                fill: Color.White,
                transform: "rotate(270deg)"
            }
        },
        colomnWrapper: {
            display: "flex",
            flexDirection: "colomn"
        },
        search: {
            display: "flex",
            margin: "2.17vw 0 1.93vw auto",
            fontSize: "4.34vw",
            paddingLeft: "1.35vh",
            color: Color.Black,
            border: "none",
            borderRadius: "2.41vw",
            backgroundColor: Color.Cultured,
            input: {
                height: "12.07vw",
                margin: "0",
                width: "43.24vw"
            },
            iconWrapper: {
                margin: "3.14vw 4.83vw 3.14vw auto",
                cursor: "pointer"
            },
            icon: {
                width: "5.31vw",
                height: "5.79vw",
                fill: Color.SharpAsh
            }
        },
        backButton: {
            wrapper: {
                display: "flex",
                alignSelf: "center",
                marginLeft: "4.83vw",
                marginTop: "5.79vw",
                width: "100%"
            },
            container: {
                display: "flex",
                alignItems: "center"
            },
            button: {
                paddingTop: "0.7vw",
                width: "6.76vw",
                height: "6.76vw",
                backgroundColor: Color.LightAsh,
                borderRadius: "50%"
            },
            icon: {
                fill: Color.DeepBlack,
                width: "50%"
            },
            text: {
                display: "inline",
                marginLeft: "2.65vw",
                fontSize: "3.86vw",                
                color: Color.LightBlack
            }
        },
        titleWrapper: {
            marginTop: "3.62vw",
            title: {
                fontSize: "6.04vw",
                fontWeight: "bold" as "bold",
                color: Color.LightBlack,
                margin: "0 4.83vw"
            }
        },
        status: {
            display: "flex",
            flexDirection: "row" as "row",
            padding: "5.79vw 2.41vw 3vw 4.83vw",
            flexWrap: "wrap",
            tag: {
                height: "8.45vw",
                lineHeight: "8.45vw",
                width: "auto",
                borderRadius: "6.04vw",
                background: Color.LightAsh,
                color: Color.SharpAsh,
                padding: "0 3.62vw",
                fontFamily: Font.Poppins,
                fontSize: "4.34vw",
                fontWeight: "500",
                margin: "0 2.41vw 2.41vw 0",
                flex: "0 0 auto"
            },
            statusDot: {
                display: "inline-block",
                width: "3.38vw",
                height: "3.38vw",
                borderRadius: "50%",
                marginRight: "2.41vw"
            },
            selected: {
                border: "2px solid" + Color.Blue,
                background: Color.LightBlue
            }
        },
        downloadAllCv: {
            margin: "4.83vw 4.83vw 0 auto",
            display: "flex",
            width: "38.93vw",
            height: "7.73vw",
            border: "2px solid " + Color.Green,
            borderRadius: "2.41vw",
            fontSize: "3.38vw",
            color: Color.LightBlack,
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer"
        },
        unreadCount: {
            display: "flex",
            margin: "2.83vw 4.83vw 0px auto",
            borderRadius: "1vw",
            padding: "1vw 2vw",
            fontSize: "3.86vw",
            color: Color.White,
            backgroundColor: Color.LightOrange
        },
        selectWrapper: {
            display: "flex",
            flexDirection: "column",
            margin: "10.38vw 4.83vw 0 4.83vw"
        },
        selectRow: {
            display: "flex",
            flexDirection: "row"
        },
        sortSelect: {
            marginLeft: "unset",                
            marginTop: "unset",
            alignSelf: "end",
            label: {
                fontWeight: "unset"
            },
            buttonWrapper: { 
                width: "40vw"
            },
            button: {
                width: "auto"
            },
            hover: {
                width: "40vw"
            }
        },
        perPageSelect: {
            marginLeft: "auto",                
            marginTop: "unset",
            label: {
                fontWeight: "unset"
            },
            buttonWrapper: { 
                width: "13.58vw"
            },
            button: {
                width: "auto",
                marginLeft: "auto"
            },
            hover: {
                width: "13.58vw"
            }
        },
        actionWrapper: {
            display: "flex",
            flexDirection: "row",
            margin: "5.79vw 0 5.79vw 6.33vw",
            checkBoxRow: {
                marginRight: "1.66vw",
                checkbox: {
                    width: "3.38vw",
                    height: "3.38vw"
                }
            },
            selectActions: {
                marginLeft: "auto"
            },
            fadeContainer: {
                opacity: "0", 
                transition: 'opacity 0.2s ease'
            },
            fadeContainerVisible: {
                opacity: "1"
            }
        },
        actionLabel: {
            fontSize: "4.83vw",
            fontFamily: Font.Poppins,
            fontWeight: "600"
        },
        topActionMenu: {
            buttonWrapper: {
                display: "flex",
                flexDirection: "row",
                marginBottom: "5.79vw"
            },
            buttons: {
                width: "30.42vw",
                height: "8.45vw",                
                borderRadius: "1.69vw",
                marginRight: "unset",
                marginLeft: "0.31vw",
                fontSize: "3.86vw",
                fontWeight: "bold"  
            },
            email: {
                color: Color.White,
                backgroundColor: Color.Green,
                margin: "0 4.83vw 0 auto"
            }
        },
        actions: {
            display: "flex",
            flexDirection: "row",
            marginLeft: "auto", 
            marginRight: "4.83vw",
            marginTop: "unset",
            label: {
                fontSize: "3.86vw",
                alignSelf: "center",
                marginRight: "2.89vw"
            },           
            buttonWrapper: { 
                padding: "0 3vw",
                width: "41.58vw",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                height: "8.45vw",
                border: "1px solid " + Color.MiddleAsh,
                borderRadius: "1.69vw",
                cursor: "pointer"
            },
            buttonText: {
                maxWidth: "32vw",
                marginLeft: "auto",
                fontSize: "3.62vw",
                color: Color.SharpAsh
            },
            buttonIcon: {
                margin: "0 auto 0 3.33vw",
                width: "3.2vw",
                height: "3.2vw",
                transition: "transform .12s ease-in-out",
                fill: Color.SharpAsh,
                hover: {
                    transform: "rotate(180deg)"
                }
            },
            hover: {
                paddingLeft: "3vw",
                width: "45.58vw",
                maxHeight: "39.61vw",
                position: "absolute",
                top: "calc(100% + 1.6vw)",
                right: 0,
                backgroundColor: Color.White,
                border: "1px solid " + Color.LightSilver,
                borderRadius: "3.73vw",
                boxShadow: "0 8px 28px rgba(16,24,40,.14), 0 2px 8px rgba(16,24,40,.08)",
                padding: "2.13vw 0 2.13vw 2.13vw",
                overflowY: "auto",
                zIndex: 10
            },
            optionWrapper: {
                display: "flex",
                alignItems: "center",
                padding: "2.4vw 0",
                borderRadius: "2.4vw",
                cursor: "pointer",
                fontSize: "3.6vw",
                color: Color.MiddleBlack,
                status: {
                    marginLeft: "1vw"
                },
                hovered: {
                    backgroundColor: Color.LightBlue
                }
            },
            optionDot: {
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                display: "block",
                marginTop: "1vw",
                marginRight: "3px"
            },
            button: {
                position: "relative",
                cursor: "pointer"
            },
            group: {
                borderBottom: "1px solid " + Color.MiddleAsh,
                lastItem: {
                    borderBottom: "none"
                }
            },
            groupHeader: {
                fontSize: '3.76vw',
                fontWeight: 600,
                color: Color.SharpAsh,
                padding: '0.96vw 2.89vw'
            }
        },
        selectAllWrapper: {
            display: "flex",
            margin: "0.41vw 0.25vw 1.02vw 0",
            checkBoxRow: {
                checkbox: {
                    width: "0.72vw",
                    height: "0.72vw",
                    borderRadius: "3px",
                    marginTop: "0.14vw"
                }
            },
            selectAllLabel: {
                color: Color.Black,
                marginTop: "0.2vw",
                fontSize: "0.78vw"
            }
        },
        candidateList: {
            backgroundColor: Color.White,
            border: "1px solid " + Color.Ash,
            borderRadius: "4.27vw",
            margin: "0 4.83vw",
            boxShadow: "0 1px 2px rgba(16,24,40,.04), 0 1px 3px rgba(16,24,40,.06)",
            noCandidates: {
                border: "none",
                boxShadow: "none"
            }
        },
        candidateCard: {
            marginTop: "0.57vw",
            paddingLeft: "1.33vw",
            paddingRight: "5.33vw",
            cursor: "pointer",
            backgroundColor: Color.White,
            borderBottom: "1px solid " + Color.MiddleAsh,
            checkBox: {
                checkboxWrapper: {
                    alignItems: "unset"
                },
                checkbox: {
                    width: "3.38vw",
                    height: "3.38vw",
                    margin: "12.56vw 0 0 1.5vw"
                }
            },
            firstItem: {
                borderTopLeftRadius: "4.1vw",
                borderTopRightRadius: "4.1vw"
            },
            lastItem: {
                borderBottomLeftRadius: "4.1vw",
                borderBottomRightRadius: "4.1vw"
            },
            userProfile: {
                display: "flex",
                flexDirection: "row" as "row"
            },
            userAvatar: {
                height: "17.87vw",
                width: "17.87vw",
                objectFit: "cover",
                borderRadius: "50%",     
                margin: "5.79vw 4.83vw 0 8.14vw"                   
            },
            nameWrapper: {
                display: "flex",
                flexDirection: "row" as "row",
                width: "50vw",
                marginTop: "5.79vw"
            },
            name: {
                color: Color.DeepAsh,
                fontSize: "3.86vw",
                fontWeight: "bold",
                maxWidth: "43vw"
            },
            crownWrapper: {
                display: "flex",
                width: "4.35vw",
                height: "4.34vw",
                backgroundColor: Color.HarvestGold,
                borderRadius: "50%",
                marginLeft: "1.45vw",
                alignItems: "center",
                justifyContent: "center"
            },
            crownIcon: {
                width: "2.64vw",
                fill: Color.White                
            },
            address: {
                color: Color.MiddleBlack,
                fontSize: "2.65vw",
                marginTop: "1.20vw"
            },
            cvLessIcon: {
                width: "4.33vw",
                height: "4.33vw",
                marginLeft: "2vw",
                fill: Color.Red
            },
            statusBadgeWrapper: {
                flexDirection: "colomn",
                marginBottom: "4.92vw"
            },
            dateWrapper: {
                display: "flex",
                flexDirection: "row",
                marginTop: "1.54vw",
                fontSize: "2.66vw",
                color: Color.MiddleBlack
            },
            calendarIcon: {
                width: "1.87vw",
                height: "2.14vw",
                fill: Color.DeepAsh,
                marginRight: "1.87vw"
            },
            applied: {
                color: Color.MiddleBlack,
                fontSize: "2.65vw",
                marginRight: "1.20vw"
            },
            date: {
                fontWeight: "bold"
            },
            statusBadge: {
                height: "5.07vw",
                lineHeight: "5.07vw",
                borderRadius: "6.04vw",
                padding: "0 3.62vw",
                fontSize: "2.89vw",
                fontWeight: "500",
                marginTop: "2.41vw",
                flex: "0 0 auto",
                textAlign: "center",
                whiteSpace: "nowrap",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "1.2vw",
                chevron: {
                    width: "2.41vw",
                    height: "2.41vw",
                    flexShrink: 0,
                    transition: "transform .12s ease-in-out",
                    open: {
                        transform: "rotate(180deg)"
                    }
                }
            },
            statusBadgeContainer: {
                position: "relative",
                width: "fit-content"
            },
            actionsMenuButton: {
                icon: {
                    display: "none"
                }
            },
            statusMenu: {
                position: "absolute",
                top: "calc(100% + 1.6vw)",
                right: 0,
                minWidth: "58vw",
                backgroundColor: Color.White,
                border: "1px solid " + Color.LightSilver,
                borderRadius: "3.73vw",
                boxShadow: "0 8px 28px rgba(16,24,40,.14), 0 2px 8px rgba(16,24,40,.08)",
                padding: "2.13vw",
                zIndex: 5,
                option: {
                    display: "flex",
                    alignItems: "center",
                    gap: "2.67vw",
                    padding: "2.4vw 2.67vw",
                    borderRadius: "2.4vw",
                    cursor: "pointer",
                    fontSize: "3.6vw",
                    color: Color.MiddleBlack,
                    current: {
                        backgroundColor: Color.SharpBlue
                    },
                    hovered: {
                        backgroundColor: Color.LightBlue
                    }
                },
                dot: {
                    width: "2.4vw",
                    height: "2.4vw",
                    borderRadius: "50%",
                    flexShrink: 0
                },
                label: {
                    flex: 1
                },
                tick: {
                    width: "3.73vw",
                    height: "3.73vw",
                    fill: Color.Blue,
                    flexShrink: 0
                },
                group: {
                    marginTop: "0.96vw",
                    borderBottom: "1px solid " + Color.MiddleAsh,
                    lastItem: {
                        borderBottom: "none"
                    }
                },
                groupHeader: {
                    fontSize: '3.76vw',
                    fontWeight: 600,
                    color: Color.SharpAsh,
                    padding: '0.96vw 2.89vw'
                }
            },
            buttons: {
                flexDirection: "column",
                marginLeft: "8.14vw",
                marginTop: "3.54vw",
                marginBottom: "5.96vw"
            },
            button: {
                width: "39.42vw",
                height: "8.45vw",                
                borderRadius: "1.69vw",
                marginRight: "unset",
                marginLeft: "0.31vw",
                fontSize: "3.86vw",
                fontWeight: "bold"                
            },
            viewCv: {
                color: Color.White,
                backgroundColor: Color.DeepBlack,
                marginBottom: "1.44vw"
            },
            answers: {
                color: Color.Blue,
                backgroundColor: Color.LightBlue,
                marginLeft: "2.01vw"
            },
            move: {
                color: Color.SharpAsh,
                backgroundColor: Color.Cultured,
            },
            notes: {
                color: Color.Red,
                backgroundColor: Color.Linen,
                marginLeft: "2.01vw"
            },
            readApplicant: {
                backgroundColor: Color.LightLavender
            },
            deleted: {
                backgroundColor: Color.LightPink
            },
            viewCvIcon: {
                display: "none"
            }
        },
        premiumMessage: {                                
            position: "absolute",
            width: "auto", 
            padding: "1.82vw",
            marginTop: "14.41vw",
            fontSize: "3.38vw",
            border: "1px solid " + Color.Gray,
            borderRadius: "1vw",
            boxShadow: "3px 3px 10px #00000029",
            backgroundColor: Color.White,
            zIndex: "1",
            pointer: {
                position: "absolute",
                width: "2.8vw",
                height: "2.8vw",
                top: "-1.8vw",
                right: "unset",
                left: "20%",
                transform: "translateX(-50%) rotate(45deg)",                    
                backgroundColor: Color.White,
                borderTop: "1px solid " + Color.Gray,
                borderLeft: "1px solid " + Color.Gray,
                boxShadow: "-5px -5px 10px #00000029",
            }
        },
        pagination: {
            nextButton: {
                width: "7.25vw",
                height: "7.25vw",
                backgroundColor: Color.DeepBlack,
                border: "none"
            },
            button: {
                color: Color.DeepAsh,
                active: {
                    backgroundColor: Color.SharpAsh
                }
            }
        },
        noApplicants: {
            wrapper: {
                borderRadius: "2.77vw",
                border: "1px solid " + Color.HarvestGold,
                backgroundColor: Color.LightGold,
                display: "flex",
                alignItems: "center" as "center",
                justifyContent: "center" as "center",
                padding: "2.41vh",
                color: Color.HarvestGold,
                fontSize: "4.5vw",
                fontFamily: Font.Poppins,
                margin: "21.73vw 3vw 0",
                textAlign: "center"
            },
            icon: {
                marginRight: "1.43vw",
                width: "8.33vw",
                height: "8.33vw",
                marginLeft: "1vw"
            }
        },
        confirmationDialog: {   
            container: {
                width: "calc(100% - 9.66vw)",
                height: "40.83vw",
                padding: "7.246vw 4.93vw",
                borderRadius: "2.415vw 2.415vw 0 0"
            },
            closeButton: {
                width: "4.58vw",
                height: "4.58vw",
                top: "3.41vw",
                right: "5.70vw"
            },
            title: {
                margin: "0 0 2.41vw",
                fontSize: "5.86vw",
                color: Color.MiddleBlack,
                lineHeight: "5vw",
                justifySelf: "center",
                fontWeight: "bold" as "bold"
            },
            message: {
                fontSize: "4vw",
                color: Color.MiddleBlack,
                justifySelf: "center",
                fontWeight: 300,
                textAlign: 'center'
            },
            cancel: {
                background: Color.LightAsh,
                borderRadius: "2.41vw",
                height: "12vw",            
                width: "42vw",       
                fontWeight: "bold" as "bold",
                color: Color.SharpAsh,
                fontSize: "4vw",
                float: "right" as "right",
                marginTop: "7vw",
                marginRight: 0,
                padding: 0
            },
            move: {
                backgroundColor: Color.Green,            
                borderRadius: "2.41vw",
                color: Color.White,
                height: "12vw",
                width: "42vw",
                border: "none",            
                fontSize: "4vw",            
                fontWeight: "bold" as "bold",
                float: "left" as "left",
                marginTop: "7vw",
                marginLeft: 0
            }                  
        },
        quotaExceededDialog: {
            container: {
                width: "calc(100% - 9.66vw)",
                height: "28vw",
                padding: "7.246vw 4.93vw",
                borderRadius: "2.415vw 2.415vw 0 0"
            },
            closeButton: {
                width: "4.58vw",
                height: "4.58vw",
                top: "3.41vw",
                right: "5.70vw"
            },
            title: {
                margin: "0 0 2.41vw",
                fontSize: "5.86vw",
                color: Color.MiddleBlack,
                lineHeight: "5vw",
                justifySelf: "center",
                fontWeight: "bold" as "bold"
            },
            confirm: {
                display: "block",
                backgroundColor: Color.Green,            
                borderRadius: "2.41vw",
                color: Color.White,
                height: "12vw",
                width: "42vw",
                border: "none",            
                fontSize: "4vw",            
                fontWeight: "bold" as "bold",
                alignSelf: "center",
                margin: "7vw auto 0"
            }   
        },
        popUpTabs: {
            container: {                
                width: "90%",
                height: "57%",
                padding: "7.48vw 4.83vw",
                borderRadius: "0",
                maxHeight: "70vh", 
                overflowY: 'auto'
            },
            closeButton: {
                width: "4.58vw",
                height: "4.58vw",
                top: "3.41vw",
                right: "5.70vw"
            } 
        },
        popUpContainer: {
            content: {
                padding: "5.79vw 4.83vw 7.48vw"
            },
            backButton: {
                display: "flex",
                alignItems: "center",
                button: {
                    paddingTop: "0.7vw",
                    width: "6.76vw",
                    height: "6.76vw",
                    backgroundColor: Color.LightAsh,
                    borderRadius: "50%"
                },
                icon: {
                    fill: Color.DeepBlack,
                    width: "50%"
                },
                text: {
                    display: "inline",
                    marginLeft: "2.65vw",
                    fontSize: "3.86vw",                
                    color: Color.LightBlack
                }
            },
            profileContainer: {
                display: "flex",
                flexDirection: "row" as "row",
                marginTop: "7.24vw"
            },
            profileImage: {
                height: "24.33vw",
                width: "24.33vw",
                objectFit: "cover",
                borderRadius: "50%"                   
            },
            detailsWrapper: {
                marginLeft: "3.85vw",
                nameWrapper: {
                    display: "flex"
                },
                name: {
                    color: Color.LightBlack,
                    fontSize: "6.03vw",
                    fontWeight: "bold" as "bold",
                    maxWidth: "53vw"
                },
                crownWrapper: {
                    display: "flex",
                    width: "5vw",
                    height: "5vw",
                    backgroundColor: Color.HarvestGold,
                    borderRadius: "50%",
                    margin: "1.3vw 0 0 1.45vw",
                    alignItems: "center",
                    justifyContent: "center"
                },
                crownIcon: {
                    width: "2.64vw",
                    fill: Color.White                
                },
                location: {
                    color: Color.LightBlack,
                    fontSize: "3.86vw",
                    marginTop: "1.81vw",
                    fontWeight: "bold" as "bold"
                },
                appliedDate: {
                    display: "flex",
                    marginTop: "4.22vw",
                    fontSize: "3.86vw",
                    color: Color.DeepAsh
                },
                applied: {
                    fontWeight: "300",
                    margin: "0 1vw 0 3.79vw"
                }, 
                text: {
                    fontWeight: "bold" as "bold",
                    maxWidth: "60vw",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis"
                },
                calendarIcon: {
                    width: "3.26vw",
                    height: "3.73vw",
                    fill: Color.DeepAsh
                },
                statusBadge: {
                    height: "5.07vw",
                    lineHeight: "5.07vw",
                    borderRadius: "6.04vw",
                    padding: "1vw 3.62vw",
                    fontSize: "4.34vw",
                    fontWeight: "500",
                    marginTop: "2.41vw",
                    flex: "0 0 auto",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "1.2vw",
                    chevron: {
                        width: "2.41vw",
                        height: "2.41vw",
                        flexShrink: 0,
                        transition: "transform .12s ease-in-out",
                        open: {
                            transform: "rotate(180deg)"
                        }
                    }
                },
                statusBadgeContainer: {
                    position: "relative",
                    width: "fit-content"
                },
                statusMenu: {
                    position: "absolute",
                    top: "calc(100% + 1.6vw)",
                    left: 0,
                    minWidth: "58vw",
                    backgroundColor: Color.White,
                    border: "1px solid " + Color.LightSilver,
                    borderRadius: "3.73vw",
                    boxShadow: "0 8px 28px rgba(16,24,40,.14), 0 2px 8px rgba(16,24,40,.08)",
                    padding: "2.13vw",
                    zIndex: 5,
                    height: "92vw",
                    overflowY: "auto",
                    option: {
                        display: "flex",
                        alignItems: "center",
                        gap: "2.67vw",
                        padding: "2.4vw 2.67vw",
                        borderRadius: "2.4vw",
                        cursor: "pointer",
                        fontSize: "3.6vw",
                        color: Color.MiddleBlack,
                        current: {
                            backgroundColor: Color.SharpBlue
                        },
                        hovered: {
                            backgroundColor: Color.LightBlue
                        }
                    },
                    dot: {
                        width: "2.4vw",
                        height: "2.4vw",
                        borderRadius: "50%",
                        flexShrink: 0
                    },
                    label: {
                        flex: 1
                    },
                    tick: {
                        width: "3.73vw",
                        height: "3.73vw",
                        fill: Color.Blue,
                        flexShrink: 0
                    },
                    group: {
                        marginTop: "0.96vw",
                        borderBottom: "1px solid " + Color.MiddleAsh,
                        lastItem: {
                            borderBottom: "none"
                        }
                    },
                    groupHeader: {
                        fontSize: '3.76vw',
                        fontWeight: 600,
                        color: Color.SharpAsh,
                        padding: '0.96vw 2.89vw'
                    }
                }
            },
            premiumMessage: {                                
                position: "absolute",
                width: "auto", 
                padding: "1.82vw",
                marginTop: "17.41vw",
                marginLeft: "-18vw",
                fontSize: "3.38vw",
                border: "1px solid " + Color.Gray,
                borderRadius: "1vw",
                boxShadow: "3px 3px 10px #00000029",
                backgroundColor: Color.White,
                zIndex: "1",
                pointer: {
                    position: "absolute",
                    width: "2.8vw",
                    height: "2.8vw",
                    top: "-1.8vw",
                    right: "15%",
                    left: "unset",
                    transform: "translateX(-50%) rotate(45deg)",                    
                    backgroundColor: Color.White,
                    borderTop: "1px solid " + Color.Gray,
                    borderLeft: "1px solid " + Color.Gray,
                    boxShadow: "-5px -5px 10px #00000029"
                }
            },
            tabs: {
                container: {
                    marginTop: "4.85vh"
                },
                tabsWrapper: {
                    display: "flex", 
                    alignItems: "center"
                },
                arrowIcon: {
                    width: "6vw",
                    height: "6vw"
                },
                linkWrapper: {
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: Color.LightAsh,
                    margin: "0",
                    width: "fit-content",
                    maxWidth: "90vw",
                    overflow: 'hidden'
                },
                link: {
                    flexShrink: "0",
                    fontSize: "3.86vw",
                    color: Color.DeepAsh,
                    borderRadius: "1.20vw",
                    padding: "2.65vw 4.65vw",
                    alignSelf: "center",
                    cursor: "pointer",
                    active: {
                        backgroundColor: Color.DeepBlack,
                        color: Color.LightAsh,
                        position: "sticky",
                        right: "0",
                        left:"0"
                    },
                    WebkitTapHighlightColor: "transparent"
                },
                contentWrapper: {}
            } 
        },
        emailContainer: {
            content: {
                padding: "5.79vw 4.83vw 7.48vw"
            },
            backButton: {
                display: "flex",
                alignItems: "center",
                marginBottom: "4.83vw",
                button: {
                    paddingTop: "0.7vw",
                    width: "6.76vw",
                    height: "6.76vw",
                    backgroundColor: Color.LightAsh,
                    borderRadius: "50%"
                },
                icon: {
                    fill: Color.DeepBlack,
                    width: "50%"
                },
                text: {
                    display: "inline",
                    marginLeft: "2.65vw",
                    fontSize: "3.86vw",                
                    color: Color.LightBlack
                }
            },
            container: {
                width: "calc(100% - 9.66vw)",
                height: "auto",
                padding: "6.246vw 4.93vw",
                borderRadius: "2.415vw 2.415vw 0 0"
            },
            title: {
                fontWeight: 700,
                fontSize: "6.04vw",
                color: Color.LightBlack
            },
            jobTitle: {
                fontSize: "6.04vw",
                fontWeight: 700,
                color: Color.DeepBlack,
                margin: "3.62vw 0 5.79vw"
            },
            actionButtons: {
                display: "flex",
                gap: "2.41vw",
                width: "auto"
            },
            sendCopyButton: {
                color: Color.Blue,
                cursor: "pointer",
                fontSize: "4.34vw",
                marginLeft: "auto"
            },
            verticalLine: {
                borderLeft: "0.95vw solid " + Color.DeepAsh
            },
            addAttachmentButton: {
                color: Color.Blue,
                cursor: "pointer",
                paddingRight: "0",
                fontSize: "4.34vw"
            },
            fieldGroup: {
                display: "flex",
                flexDirection: "column",      
                marginTop: "2.41vw"
            },
            label: {
                fontSize: "3.86vw",
                marginTop: "1.04vw",
                color: Color.DeepAsh,
                fontFamily: Font.Poppins,
                recipients: {
                    marginTop: "2.43vw"
                }
            },
            input: {
                padding: "1.93vw",
                border: "1px solid" + Color.MiddleAsh,
                backgroundColor: Color.White,
                borderRadius: "1.44vw",
                marginTop: "1.20vw",
                fontSize: "3.38vw"
            },
            emailInputWrapper: {
                display: 'flex',
                position: "relative",
                boxSizing: "border-box",
                minHeight: "12.08vw",
                flexWrap: 'wrap',    
                padding: '1.93vw 2.89vw',
                border: "1px solid" + Color.MiddleAsh,
                marginTop: "1.2vw",
                alignItems: "center",
                borderRadius: '1.44vw',
                content: {
                    width: "95%"
                },
                input: {
                    border: "none",
                    outline: "none",
                    fontSize: "3.38vw",
                    backgroundColor: "transparent",
                    padding: "0"
                }
            },
            emailTag: {
                display: 'inline-flex',
                alignItems: 'center',
                backgroundColor: Color.SharpGreen,
                border: '1px solid' + Color.Green,
                borderRadius: '3.86vw',
                padding: '1.20vw 2.89vw',
                gap: '1.93vw',
                fontFamily: Font.Poppins,
                fontSize: '3.38vw',
                margin: "0 1.5vw 1.5vw 0",
                width: "fit-content",
                text: {
                    color: Color.Black,
                    lineHeight: '1.2',
                    wordBreak: 'break-word'
                },
                removeButton: {
                    cursor: 'pointer',
                    width: '4.34vw',
                    height: '4.34vw',
                    overflow: "visible"
                }
            },
            emailInputField: {
                border: 'none',
                width: '100%',
                fontSize: '3.38vw',
                padding: '1.2vw'
            },
            emailEditor: {
                marginTop: "1.2vw",
                borderRadius: "1.44vw",
                border: "0.24vw solid" + Color.MiddleAsh
            },
            actions: {
                display: "flex",
                justifyContent: "flex-end",
                gap: "2.41vw",
                marginTop: "2.89vw"
            },
            sendButton: {
                backgroundColor: Color.Green,
                fontWeight: "bold",
                color: Color.White,
                width: "43.96vw",
                height: "9.66vw",
                fontSize: "3.86vw",
                padding: "1.93vw 3.86vw",
                borderRadius: "1.44vw"
            },
            cancelButton: {
                backgroundColor: Color.MiddleBlack,
                fontWeight: "bold",
                color: Color.White,
                width: "43.96vw",
                height: "9.66vw",
                fontSize: "3.86vw",
                padding: "1.93vw 3.86vw",
                borderRadius: "1.44vw"
            },
            attachment: {
                display: 'flex',
                flexWrap: 'wrap',
                marginTop: "1.2vw",
                padding: "1.93vw 2.89vw",
                border: "1px solid" + Color.MiddleAsh,
                borderRadius: '1.44vw',
                boxSizing: "border-box",
                height: "12.08vw",
                alignItems: "center",
                overflow: 'hidden'
            },
            attachmentItem: {
                display: 'flex',
                gap: '1.93vw',
                fontFamily: Font.Poppins,
                fontSize: '3.38vw'
            },
            attachmentName: {
                color: Color.Black,
                wordBreak: 'break-word'
            },
            attachmentRemove: {
                cursor: 'pointer',
                width: '4.34vw',
                height: '4.34vw',
                marginTop: '1vw',
                overflow: "visible"
            },
            valid: {
                backgroundColor: Color.LightBlue,
                border: "1px solid " + Color.Blue
            },
            invalid: {
                backgroundColor: Color.CoralRed,
                border: "1px solid " + Color.Red,
                color: Color.Red
            },
            invalidMessage: {
                position: "absolute",
                right: "2.2%"
            },
            inputError: {
                width: "max-content",
                icon: {
                    width: "4.17vw",
                    height: "4.17vw",
                    overflow: "unset"
                }
            }
        },
        statusBoxes: {
            display: "flex",
            flexDirection: "row" as "row",
            flexWrap: "wrap",
            padding: "0 4.83vw 3vw",
            marginTop: '3vw',
            box: {
                display: "flex",
                flexDirection: "column" as "column",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "18vw",
                borderRadius: "2.41vw",
                background: Color.White,
                border: "1px solid " + Color.MiddleAsh,
                padding: "2.41vw 3.62vw",
                margin: "0 2.41vw 2.41vw 0",
                cursor: "pointer",
                count: {
                    fontSize: "5.31vw",
                    fontWeight: "bold" as "bold",
                    color: Color.DeepBlack
                },
                label: {
                    fontSize: "3.14vw",
                    color: Color.SharpAsh,
                    marginTop: "0.72vw"
                }
            },
            selected: {
                border: "2px solid" + Color.Blue
            }
        }
    },
    desktop: {
        mainWrapper: {            
            flexDirection: "row" as "row",
            padding: "1.56vw"
        },        
        leftWrapper: {},
        rightWrapper: {
            width: "100%",
            paddingLeft: "2.32vw"
        },
        searchWrapper: {
            height: "4.68vw"
        },
        profileWrapper: {
            display: "flex",
            marginLeft: "auto"
        },
        backButton: {            
            wrapper: {
                display: "block",
                marginLeft: "unset",
                marginTop: "unset",
                width: "7vw"                 
            },
            button: {
                paddingTop: "0.3vw",
                backgroundColor: Color.Ash, 
                width: "2.60vw",
                height: "2.60vw"
            },
            text: {
                marginLeft: "1.3vw",
                fontSize: " 0.93vw",
                fontWeight: 'bold'
            }          
        },
        titleWrapper: {
            marginTop: "2.5vw",
            display: "flex",
            flexDirection: "row" as "row",
            justifyContent: "space-between",
            title: {
                color: Color.DeepBlack,
                fontSize: "1.56vw",
                margin: "unset",
                width: "56vw",
                expanded: {
                    width: "45vw"
                }
            }
        },
        search: {
            margin: "unset",
            height: "2.6vw",
            fontSize: "0.93vw",
            paddingLeft: "0.52vw",
            borderRadius: "0.52vw",
            input: {
                height: "2.40vw",
                margin: "0",
                width: "19.53vw"
            },
            iconWrapper: {
                margin: "0.67vw 1.04vw 0.67vw auto"
            },
            icon: {
                width: "1.14vw",
                height: "1.25vw"
            }
        },
        status: {
            padding: "1.67vw 0 0.3vw 0.42vw",
            alignItems: "center",
            showSideMenu: {
                maxWidth: "73.5vw"
            },
            tag: {
                height: "1.82vw",
                lineHeight: "1.82vw",
                borderRadius: "1.30vw",
                padding: "0 1.04vw",
                fontSize: "0.94vw",
                margin: "0 0.52vw 0.52vw 0",
                cursor: "pointer"
            },
            statusDot: {
                width: "0.72vw",
                height: "0.72vw",
                marginRight: "0.52vw"
            }
        },
        content: {
            display: "flex"
        },
        downloadAllCv: {
            margin: "0 0 0 auto",
            width: "12.65vw",
            height: "1.82vw",
            borderRadius: "0.52vw",
            fontSize: "0.94vw"
        },
        unreadCount: {
            margin: "0 0 0 auto",
            borderRadius: "0.52vw",
            padding: "unset",
            width: "12.85vw",
            height: "1.82vw",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "0.94vw"
        },
        selectWrapper: {
            flexDirection: "row",
            margin: "1.56vw 0 0 0"
        },
        sortSelect: {
            label: {
                fontSize: "0.83vw"
            },
            buttonWrapper: { 
                width: "11vw"
            },
            button: {
                height: "1.82vw",
                marginLeft: "unset"
            },
            hover: {
                width: "11vw"
            },
            option: {
                hover: {
                    margin: "0 0 0 1vw"
                },
                leave: {
                    margin: "0 0 0 1vw"
                }
            }
        },
        perPageSelect: {
            marginBottom: "unset",
            marginLeft: "unset",
            label: {
                fontSize: "0.83vw",
                fontWeight: "300"
            },
            buttonWrapper: { 
                width: "4.06vw"
            },
            button: {
                height: "1.82vw",
                marginLeft: "1.04vw"
            },
            hover: {
                width: "4.06vw"
            }
        },
        topActionMenu: {
            buttonWrapper: {
                margin: "0.1vw 0 0 0" 
            },
            buttons: {
                width: "9.65vw",
                height: "1.82vw",
                borderRadius: "0.52vw",
                fontSize: "0.94vw"
            },
            email: {
                margin: "0 0 0 1.04vw"
            }
        },
        actions: {
            marginLeft: "0.83vw",
            marginRight: "unset",
            label: {
                fontSize: "0.83vw",
                marginRight: "unset" 
            }, 
            buttonWrapper: {
                padding: "unset",
                borderRadius: "0.52vw",
                width: "14.06vw",
                height: "1.82vw"
            },
            buttonText: {
                fontSize: "0.86vw",
                maxWidth: "none"
            },
            buttonIcon: {
                height: "0.8vw",
                width: "0.8vw",
                marginLeft: "1vw"
            },
            button: {
                height: "1.82vw",
                marginLeft: "1.04vw"
            },
            hover: {
                padding: "0.52vw 0 0.52vw 0.52vw",
                borderRadius: "0.52vw",
                width: "13.56vw",
                marginLeft: "unset",
                top: "unset",
                maxHeight: "8.61vw"
            },
            optionWrapper: {
                padding: "0.59vw 0.65vw",
                borderRadius: "0.52vw",
                fontSize: "0.88vw",
                gap: "0.65vw",
                status: {
                    marginLeft: "unset"
                }
            },
            optionDot: {
                width: "7px",
                height: "7px",
                marginTop: "unset",
                alignSelf: "center",
                marginRight: "4px"
            },
            group: {
                marginTop: "0.59vw"
            },
            groupHeader: {
                fontSize: '0.83vw',
                padding: '0.2vw 0.625vw'
            }
        },
        selectAllWrapper: {
            marginRight: "0"
        },
        candidateList: {
            borderRadius: "1.04vw",
            margin: "unset"
        },
        candidateCard: {
            margin: "unset",
            paddingLeft: "1.3vw",
            paddingRight: "1.3vw",
            checkBox: {
                checkbox: {
                    width: "0.72vw",
                    height: "0.72vw",
                    borderRadius: "3px",
                    margin: "2.62vw 0 0 0.25vw"
                }
            },
            firstItem: {
                borderTopLeftRadius: "0.93vw",
                borderTopRightRadius: "0.93vw"
            },
            lastItem: {
                borderBottomLeftRadius: "0.93vw",
                borderBottomRightRadius: "0.93vw"
            },
            userAvatar: {
                height: "3.85vw",
                width: "3.85vw",
                margin: "1.02vw 1.04vw 1vw 2.08vw"
            },
            details: {
                width: "40vw",
                expanded: {
                    width: "26vw"
                }
            },
            nameWrapper: {
                marginTop: "1.74vw",
                maxWidth: "10.5vw",
                listView: {
                    maxWidth: "25.5vw"
                },
                expanded: {
                   maxWidth: "18vw"
                },
                expandedAndHovered: {
                    width: "6.5vw",
                    maxWidth: "6.5vw"
                }
            },
            name: {
                fontSize: "1.04vw",
                maxWidth: "11vw",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                listView: {
                    maxWidth: "18vw"
                },
                listViewAndExpanded: {
                    maxWidth: "18vw"
                },
                expanded: {
                   maxWidth: "9vw"
                },
                expandedAndHovered: {
                    width: "5vw",
                    maxWidth: "5vw"
                }
            },
            crownWrapper: {
                width: "1.2vw",
                height: "1.2vw",
                marginLeft: "0.2vw"
            },
            crownIcon: {
                width: "1.3vw",
                height: "0.6vw"
            },
            address: {
                fontSize: "0.83vw",
                marginTop: "0.28vw",
                maxWidth: "8.5vw",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                listView: {
                    maxWidth: "22.5vw"
                },
                expanded: {
                   maxWidth: "15.5vw"
                },
                expandedAndHovered: {
                    width: "auto",
                    maxWidth: "4.5vw"
                }
            },
            cvLessIcon: {
                width: "1vw",
                height: "1vw",
                marginLeft: "0.5vw",
                marginTop: "0.3vw"
            },
            dateWrapper: {
                flexDirection: "column",
                fontSize: "0.83vw",
                width: "17vw",
                marginLeft: "auto",
                marginTop: "unset",
                alignSelf: "center"
            },
            listView: {
                hovered: {
                   marginLeft: "auto"
                },
                expanded: {
                    marginLeft: "auto"
                },
                expandedAndHovered: {
                    marginLeft: "auto"
                }
            },
            appliedDate: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-end"
            },
            calendarIcon: {
                width: "0.70vw",
                height: "0.80vw",
                marginRight: "0.82vw"
            },
            dateContainer: {
                display: "flex",
                alignItems: "center",
                whiteSpace: "nowrap"
            },
            applied: {
                color: Color.DeepAsh,
                fontSize: "0.83vw",
                marginRight: "0.3vw"
            },
            date: {
                color: Color.DeepAsh,
                fontSize: "0.83vw"
            },
            statusWrapper: {
                display: "flex",
                width: "14.27vw",
                margin: "0 0 0 1vw",
                expanded: {
                    margin: "0 0 0 1vw"
                },
                expandedAndHovered: {
                    width: "12.27vw"
                }
            },
            statusBadgeContainer: {
                position: "relative",
                width: "fit-content",
                alignSelf: "flex-start"
            },
            actionsMenuContainer: {
                position: "relative",
                width: "fit-content",
                alignSelf: "center",
                marginLeft: "0.5vw"
            },
            actionsMenuButton: {
                width: "2.34vw",
                height: "2.34vw",
                borderRadius: "0.65vw",
                border: "none",
                background: "transparent",
                color: Color.SharpAsh,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 0,
                hover: {
                    background: Color.Ash
                },
                icon: {
                    display: "flex",
                    width: "1.17vw",
                    height: "1.17vw",
                    fill: Color.SharpAsh
                }
            },
            actionsMenu: {
                position: "absolute",
                top: "calc(100% + 0.39vw)",
                right: 0,
                minWidth: "10.72vw",
                backgroundColor: Color.White,
                border: "1px solid " + Color.LightSilver,
                borderRadius: "0.85vw",
                boxShadow: "0 8px 28px rgba(16,24,40,.14), 0 2px 8px rgba(16,24,40,.08)",
                padding: "0.39vw",
                zIndex: 5,
                display: "flex",
                flexDirection: "column",
                gap: "0.13vw"
            },
            actionsMenuItem: {
                display: "flex",
                alignItems: "center",
                width: "100%",
                border: "none",
                background: "none",
                padding: "0.59vw 0.65vw",
                borderRadius: "0.59vw",
                fontSize: "0.88vw",
                color: Color.MiddleBlack,
                cursor: "pointer",
                textAlign: "left",
                hover: {
                    backgroundColor: Color.LightAsh
                },
                disabled: {
                    color: Color.SharpAsh,
                    cursor: "not-allowed"
                },
                icon: {
                    width: '1.34vw',
                    height: '1.34vw',
                    marginRight: "1vw",
                    flexShrink: 0
                }
            },
            statusBadge: {
                height: "1.82vw",
                lineHeight: "1.82vw",
                borderRadius: "1.30vw",
                padding: "0 0.83vw",
                fontSize: "0.94vw",
                marginTop: "2.07vw",
                cursor: "pointer",
                whiteSpace: "nowrap",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "0.3vw",
                expandedAndHovered: {
                    padding: "0 0.3vw"
                },
                chevron: {
                    width: "0.6vw",
                    height: "0.6vw",
                    flexShrink: 0,
                    transition: "transform .12s ease-in-out",
                    open: {
                        transform: "rotate(180deg)"
                    }
                }
            },
            statusMenu: {
                top: "calc(100% + 0.39vw)",
                minWidth: "12.63vw",
                borderRadius: "0.91vw",
                boxShadow: "0 8px 28px rgba(16,24,40,.14), 0 2px 8px rgba(16,24,40,.08)",
                padding: "0.52vw",
                zIndex: 11,
                option: {
                    gap: "0.65vw",
                    padding: "0.59vw 0.65vw",
                    borderRadius: "0.59vw",
                    fontSize: "0.88vw"
                },
                dot: {
                    width: "0.59vw",
                    height: "0.59vw"
                },
                label: {
                    whiteSpace: "nowrap"
                },
                tick: {
                    width: "0.73vw",
                    height: "0.73vw"
                },
                group: {
                    marginTop: "0.59vw"
                },
                groupHeader: {
                    fontSize: '0.83vw',
                    padding: '0.2vw 0.625vw'
                }
            },
            hovered: {
                backgroundColor: "#FBFCFD",
                boxShadow: "10px 10px 50px #00000014"
            },
            viewCvIcon: {
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                icon: {
                    width: "1.77vw",
                    height: "1.77vw"
                }
            }
        },
        premiumMessage: {
            borderRadius: "0.6vw",                
            padding: "0.625vw",
            marginTop: "4.2vw",
            marginLeft: "5.2vw",
            fontSize: "0.83vw",
            pointer: {
                top: "-0.4vw",
                bottom: "unset",
                width: "0.7vw",
                height: "0.6vw"
            }
        },
        paginationWrapper: {
            display: "flex",
            alignItems: "center",
            marginTop: "2.10vw",
            singleApplicant: {
                marginTop: "16.1vw"
            }
        },
        pagination: {
            margin: "unset",
            marginLeft: "auto",
            nextButton: {
                width: "2.60vw",
                height: "2.60vw",
                lessMargin: {
                    marginLeft: "1.56vw"
                }
            }
        },
        noApplicants: {
            wrapper: {
                width: "75%",
                borderRadius: "0.52vw",
                margin: "10vh auto 0 auto",
                padding: "1.56vw 0 1.56vw 0",
                fontSize: "1.137vw"
            },
            icon: {
                marginRight: "1.02vw",
                width: "1.58vw",
                height: "1.58vw"
            }
        },
        confirmationDialog: {            
            zIndex: "12",
            container: {                
                width: "30vw",
                height: "10vw",
                maxHeight: "31.61vw",
                padding: "2.48vw 2.12vw",
                borderRadius: "0.52vw"
            },
            closeButton: {
                fill: Color.Gainsboro,
                stroke: Color.Gainsboro,
                strokeWidth: 4,
                width: "0.59vw",
                height: "0.59vw",
                top: "0.90vw",
                right: "0.90vw"
            },
            title: {
                margin: "0 1vw 1vw",
                fontSize: "1.6vw",
                lineHeight: "2vw",
                fontWeight: "500"
            },
            message: {
                fontSize: "0.94vw",
                marginBottom: "1.5vw"
            },
            buttons: {
                display: "flex"
            },
            cancel: {
                borderRadius: "0.52vw",
                height: "4.20vw",
                width: "14vw",         
                fontSize: "1.6vw",
                float: "left" as "left",
                marginTop: "unset"
            },
            move: {
                borderRadius: "0.52vw",
                height: "4.20vw",
                width: "14vw",
                fontSize: "1.6vw",            
                float: "right" as "right",
                margin: "0 1vw 0 0"
            }
        },
        quotaExceededDialog: {
            container: {                
                width: "26vw",
                height: "8vw",
                maxHeight: "31.61vw",
                padding: "2.48vw 2.12vw",
                borderRadius: "0.52vw"
            },
            closeButton: {
                fill: Color.Gainsboro,
                stroke: Color.Gainsboro,
                strokeWidth: 4,
                width: "0.59vw",
                height: "0.59vw",
                top: "0.90vw",
                right: "0.90vw"
            },
            title: {
                margin: "0 1vw 1vw",
                fontSize: "1.6vw",
                lineHeight: "2vw",
                fontWeight: "500"
            },
            confirm: {
                borderRadius: "0.52vw",
                height: "3.20vw",
                width: "8vw",
                fontSize: "1.6vw",            
                margin: "2vw auto 0"
            } 
        },
        popUpTabs: {            
            container: {  
                position: "absolute",            
                width: "30vw",
                right: "-30vw",
                top: 0,
                height: "100%",
                padding: "1.56vw 2.6vw",
                borderRadius: "unset",
                maxHeight: "unset", 
                overflowY: 'auto',
                scrollbarWidth: "none",
                transition: "right 0.35s ease-in-out"
            },
            containerOpen: {
                right: 0
            },
            closeButton: {
                width: "1.34vw",
                height: "1.34vw",
                top: "0.52vw",
                right: "0.52vw",
                overflow: "visible"
            }                      
        },
        popUpContainer: {
            content: {
                padding: "0 0 2vw 0"
            },
            profileContainer: {
                marginTop: "unset",
                width: "30vw"
            },
            profileImage: {
                height: "7.91vw",
                width: "7.91vw"                  
            },
            detailsWrapper: {
                marginLeft: "1.35vw",
                name: {
                    color: Color.DeepBlack,
                    fontSize: "1.56vw",
                    maxWidth: "19vw"
                },
                crownWrapper: {
                    width: "1.5vw",
                    height: "1.5vw",
                    margin: "0.3vw 0 0 0.2vw"
                },
                crownIcon: {
                    width: "1.04vw",
                    height: "1.48vh"
                },
                location: {
                    fontSize: "0.93vw",
                    marginTop: "0.23vw"
                },  
                appliedDate: {
                    marginTop: "0.91vw"
                },
                applied: {
                    margin: "0 0.4vw 0 0.81vw"
                },
                text: {
                    fontSize: "0.83vw",
                    maxWidth: "18vw"
                },
                calendarIcon: {
                    width: "0.70vw",
                    height: "0.80vw"
                },
                statusBadge: {
                    height: "1.82vw",
                    lineHeight: "1.82vw",
                    borderRadius: "1.30vw",
                    padding: "0 1.04vw",
                    fontSize: "0.94vw",
                    marginTop: "0.61vw",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "0.3vw",
                    chevron: {
                        width: "0.6vw",
                        height: "0.6vw",
                        flexShrink: 0,
                        transition: "transform .12s ease-in-out",
                        open: {
                            transform: "rotate(180deg)"
                        }
                    }
                },
                statusBadgeContainer: {
                    position: "relative",
                    width: "fit-content"
                },
                statusMenu: {
                    top: "calc(100% + 0.39vw)",
                    minWidth: "13.63vw",
                    borderRadius: "0.91vw",
                    padding: "0.52vw",
                    height: "30vw",
                    option: {
                        gap: "0.65vw",
                        padding: "0.59vw 0.65vw",
                        borderRadius: "0.59vw",
                        fontSize: "0.88vw"
                    },
                    dot: {
                        width: "0.59vw",
                        height: "0.59vw"
                    },
                    label: {
                        whiteSpace: "nowrap"
                    },
                    tick: {
                        width: "0.73vw",
                        height: "0.73vw"
                    },
                    group: {
                        marginTop: "0.59vw"
                    },
                    groupHeader: {
                        fontSize: '0.83vw',
                        padding: '0.2vw 0.625vw'
                    }
                }
            },
            premiumMessage: {
                width: "8vw",
                borderRadius: "0.6vw",                
                padding: "0.625vw",
                marginTop: "5.2vw",
                marginLeft: "-50px",
                fontSize: "0.83vw",
                pointer: {
                    top: "-0.4vw",
                    left: "6.3vw",
                    right: "unset",
                    bottom: "unset",
                    width: "0.7vw",
                    height: "0.6vw"
                }
            },
            tabs: {
                container: {
                    marginTop: "3.37vh"
                },
                arrowIcon: {
                    width: "1vw",
                    height: "1vw"
                },
                linkWrapper: {
                    maxWidth: "30vw",
                    width: "fit-content",
                    borderRadius: "0.52vw"
                },
                link: {
                    fontSize: "0.83vw",
                    borderRadius: "0.52vw",
                    padding: "0.67vw 1.562vw",
                    active: {
                        borderRadius: "0.52vw"                    
                    }
                },
                title: {
                    fontSize: "1.56vw",
                    marginTop: "4.63vh"
                } 
            }
        },
        emailContainer: {
            zIndex: "11",
            content: {
                padding: "0 0 2vw 0",
                maxHeight: "31.61vw",
                scrollbarWidth: "none",
                overflowY: "auto"
            },
            backButton: {
                display: "none"
            },
            container: {                
                width: "60vw",
                height: "auto",
                padding: "2.48vw 2.12vw",
                borderRadius: "0.52vw",
            },
            actionButtons: {
                gap: "1vw"
            },
            sendCopyButton: {
                fontSize: "0.93vw"
            },
            verticalLine: {
                borderLeft: "0.4vw solid " + Color.DeepAsh
            },
            addAttachmentButton: {
                fontSize: "0.93vw"
            },
            title: {
                fontSize: "1.30vw"
            },
            jobTitle: {
                fontSize: "1.56vw",
                margin: "0.5vw 0"
            },
            fieldGroup: {
                marginTop: "1.04vw"
            },
            label: {
                fontSize: "0.93vw",
                marginTop: "unset",
                recipients: {
                    marginTop: "unset"
                }
            },
            input: {
                padding: "0.52vw 1.04vw",
                borderRadius: "0.52vw",
                marginTop: "0.52vw",
                fontSize: "1.04vw",
                inputError: {
                    right: "0%"
                }
            },
            emailInputWrapper: {
                marginTop: "0.52vw",
                minHeight: "3.64vw",
                padding: "0.52vw 1.04vw",
                borderRadius: "0.52vw",
                content: {
                    display: 'block',
                    width: "98%"
                },
                input: {
                    fontSize: "0.93vw"
                }
            },
            emailTag: {
                borderRadius: '0.83vw',
                padding: "0.52vw 1.04vw",
                gap: '1.04vw',
                fontSize: "0.93vw",
                margin: "0 0.5vw 0.5vw 0",
                removeButton: {
                    width: '1vw',
                    height: '1vw',
                    alignSelf: "center"
                }
            },
            emailInputField: {
                fontSize: "1.04vw",
                width: '54.93vw',
                padding: '0.52vw'
            },
            emailEditor: {
                marginTop: "1vw",
                minHeight: "22.76vw",
                borderRadius: "0.52vw",
                width: "auto",
                border: "0.05vw solid" + Color.MiddleAsh
            },
            actions: {
                gap: "1.04vw",
                marginTop: "1.04vw"
            },
            sendButton: {
                padding: "0.52vw 1.04vw",
                borderRadius: "0.52vw",
                fontSize: "0.83vw",
                width: "10.93vw",
                height: "2.60vw"
            },
            cancelButton: {
                padding: "0.52vw 1.04vw",
                borderRadius: "0.52vw",
                fontSize: "0.83vw",
                width: "10.93vw",
                height: "2.60vw"
            },
            attachment: {
                marginTop: "0.52vw",
                padding: "0.52vw 1.04vw",
                borderRadius: '0.52vw',
                height: "3.64vw"
            },
            attachmentItem: {
                gap: '1.04vw',
                fontSize: "0.93vw"
            },
            attachmentRemove: {
                width: '1vw',
                marginTop: '0.2vw',
                height: '1vw'
            },
            invalidMessage: {
                right: "1.8%"
            },
            inputError: {
                fontSize: "1vw",
                icon: {
                    width: "1.05vw",
                    height: "1.05vw"
                }
            }
        },
        statusBoxes: {
            padding: "1.67vw 0 0.3vw 0.42vw",
            marginTop: 'unset',
            box: {
                minWidth: "5.5vw",
                borderRadius: "0.55vw",
                padding: "0.55vw 0.83vw",
                margin: "0 0.52vw 0.52vw 0",
                count: {
                    fontSize: "1.15vw"
                },
                label: {
                    fontSize: "0.73vw",
                    marginTop: "0.15vw"
                }
            }
        }
    }
}